// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDkBrR08QudPjEPXFXJNDHPhmbgHEW9KqY",
  authDomain: "kotyaltraders-425e0.firebaseapp.com",
  projectId: "kotyaltraders-425e0",
  storageBucket: "kotyaltraders-425e0.firebasestorage.app",
  messagingSenderId: "651517395837",
  appId: "1:651517395837:web:3ddb244bdec5846ad5c214",
  measurementId: "G-1XGY25SMDC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, auth, db, storage };
